import React from 'react';

const Breadcrumbs = () => {
    return (
        <div className="breadcrumbs_area">
            <div className="container">
            </div>
        </div>
    );
};

export default Breadcrumbs;